<template>
  <layout>
    <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
    <div slot="content">
      <div class="btn-type1">
        <el-button size="mini" type="primary" icon="el-icon-search" @click="goOpen">
          {{ this.$i18n.messages[this.$store.state.locale].search }}
        </el-button>
        <el-button size="mini" type="success" icon="el-icon-plus" @click="save">
          자재요청
        </el-button>
      </div>
      <div class="pop-content-search">
        <el-form size="mini" label-width="65px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="제조사">
                <el-select v-model="form.maker" >
                  <el-option value='' label="전체">==전체==</el-option>
                  <el-option
                      v-for="item in combos['Maker']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="제품군">
                <el-select v-model="form.itemGroup" @change="onCatIdChange">
                  <el-option value='' label="전체">==전체==</el-option>
                  <el-option
                      v-for="item in combos['ItemGroup']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="form.subItemGroup" v-show="subItemGroupShow">
                  <el-option value='' label="전체">==전체==</el-option>
                  <el-option
                      v-for="item in combos['SubItemGroup']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="대표모델">
                <el-input type="text" v-model="form.useModelNm" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="품번">
                <el-input type="text" v-model="form.itemCd" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="품명">
                <el-input type="text" v-model="form.itemNm" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="table-area">
        <div class="table-b">
          <ag-grid-vue
              style="width: 100%; height: 320px;"
              class="ag-theme-alpine"
              :column-defs="columnDefs"
              :grid-options="gridOptions"
              :row-data="rowData"
              :default-col-def="defaultColDef"
              :statusBar="statusBar"
              :framework-components="frameworkComponent"
              :enableRangeSelection="true"
              @grid-ready="onGridReady"
              @cell-clicked="onCellClicked"
              @cell-value-changed="onItemCellValueChange"
              :stopEditingWhenCellsLoseFocus="true"
              />
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@/components/Slot/ModalSlot.vue';
import {AgGridVue} from 'ag-grid-vue';
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";

/**
 * Url JOIN
 */
function comma(val){
  return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}


export default {
  props: {
    data: {
      Type: Array
      , required: false
    },
  },
  components: {Layout, AgGridVue},

  data() {
    return {
      title: '요청자재등록',
      form: {
        companyId : '',
        maker : '',             // 제조사
        itemGroup : '',         // 제품군
        subItemGroup: '',       // 제품군
        useModelNm : '',        // 모델명 (팝업에서 모델명 입력하지 않았을 경우 사용 )
        modelNm : '',           // 모델명 (팝업에서 모델명 입력했을 경우 사용 )
        description : '',       // 구분
        itemCd : '',            // 품번
        itemNm : '',            // 품명
        asAgentId : '',
        sortType : '',
        page : 1,
        totalPage : 99999,
        curPage : 0,
        totalCount : 99999,
        processTime : '',
        qty: 0,
        memo: ''
      },

      // AG-GRID OPTION [START]
      rowData:[],
      columnDefs: [],
      gridOptions: {},
      subItemGroupShow : false,   /** sub제품군 여부**/
      combos: {
        'Maker' : [],
        'ItemGroup' : [],
        'SubItemGroup' : [],
      },
      defaultColDef: {
        resizable: true,
        filter:true,
        sortable: true
      },
      frameworkComponent : {
        maskEdit: MaskEditCellRenderer,
        checkBox: CheckboxCellRenderer
      },
      statusBar: null
    }
  },
  mounted() {
    this.form.companyId = this.$store.state.loginInfo.compCd;
    this.getCombo();
    this.getConfigValue()
  },
  methods: {
    closeModal() {
      this.$parent.close();
    },
    onGridReady(){
      this.init();
    },
    createMainColumnDefs() {
      let that = this;
      this.columnDefs = [
        {
          headerName:'선택',
          field:'chk',
          width:80,
          cellStyle : {textAlign: 'center'},
          cellRenderer: 'checkBox',
          cellRendererParams: (params) => {
            return {
              trueValue: 'Y',
              falseValue: 'N',
              disabled: params.data.itemCd === null ? false : true
            }
          }
        },
        {headerName: '버전', width:70, field:'verId', cellStyle:{textAlign:'center'}},
        {headerName: '구분', width: 110, field:'gubun', cellStyle:{textAlign:'center'},
          valueFormatter: (params) => {
            return "보유자재";
          }
        },
        {headerName: '제조사', width:120, field:'makerNm', cellStyle:{textAlign:'center'}},
        {headerName: '제품군', width:120, field:'itemGroupNm', cellStyle:{textAlign:'center'}},
        {headerName: '품번', width:180, field:'itemCd'},
        {headerName: '품명', width:180, field:'itemNm'},
        {headerName: '대표모델', width:180, field:'useModelNm', cellStyle:{textAlign:'left'}},
        {headerName: '모델', width:180, field:'modelNm', cellStyle: {textAlign: 'center'}},
        {headerName: '품명', width:180, field:'itemNm', cellStyle:{textAlign:'left'}},
        {headerName: '규격', width:180, field:'itemSpec', cellStyle:{textAlign:'left'}},
        {headerName: '운영단가', width:120, field:'unitPrice2', cellStyle:{textAlign:'right'},
          valueFormatter: (params) => {
            return that.chkNumber(params, '', '');
          }
        },
        {headerName: '소비자가', width:120, field:'unitPrice3', cellStyle:{textAlign:'right'},
          valueFormatter: (params) => {
            return that.chkNumber(params, '', '');
          }
        },
        {headerName: '보유재고', width:120, field: 'invtGoodQty', cellStyle:{textAlign:'right'}},
        {headerName: '요청수량', width: 120, field:'qty',editable: true,
          cellStyle:{textAlign: 'right', backgroundColor: '#fff8f7'},
          valueFormatter: (params) => {
            return that.getNumberFormat(params.value);
          }
        },
        {headerName: '메모', width: 100, field:'memo',editable: true,
          cellStyle:{textAlign: 'right', backgroundColor: '#fff8f7'},
          valueFormatter: (params) => {
            return params.value;
          }
        }
      ];
    },
    onItemCellValueChange(params){
      const field = params.colDef.field;
      const regex = /[^0-9]/g

      if(field === 'qty'){
        let vQty = JSON.stringify(params.data.qty)
        vQty = params.data.qty.replace(regex, '')
        params.data.qty = vQty

        if(!(isNaN(vQty))){
          params.data.amt = comma(vQty)
        }
        this.qtyChangeCnt++
      }
    },
    rowDoubleClick(params){
      this.$emit('close', params.data);
    },
    onCellClicked(params) {
      //   this.$emit('close', params.data);
      //   this.closeModal();
      const idx = params.rowIndex;
      const field = params.colDef.field;
    },
    getCombo() {
      this.getMakerCombo();
      this.getItemGroupCombo();
    },
    getConfigValue() {
      this.$http.get(`/api/config/keyPath/info`, {params: {keyPath: 'System.MainAsAgentId'}})
          .then(response => {
            this.form.asAgentId = response.data[0].configValue;
          });
    },
    getMakerCombo(){
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: 196} })
          .then(response => {
            this.combos['Maker'] = response.data || []
          });
    },
    getItemGroupCombo(){
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: 143} })
          .then(response => {
            this.combos['ItemGroup'] = response.data || []
          });
    },
    onCatIdChange(param){
      this.form.subItemGroup = '';
      if(param === '' ) this.subItemGroupShow =  false;
      else{
        this.subItemGroupShow =  true;
        this.$http.get(`/api/codeMng/detail`, { params: {parentId: 143} })  // 제품군
            .then(response => {
              let subData = response.data.filter(x => x.catKey === param);
              this.$http.get(`/api/codeMng/combo`, { params: {parentId: subData[0].catId} })
                  .then(response => {
                    this.combos['SubItemGroup'] = response.data || []
                  });
            });
      }
    },
    save() {
      var list = this.rowData.filter(z => z.chk === 'Y')

      if (list.length > 0) {
        let result = [];
        let saveForm = {};

        list.forEach(x => {
          saveForm = {
            productType: 'Item',
            requestType: 'HoldItem',
            requestAsAgentId: this.$store.state.loginInfo.asAgentId,
            requestUserId: this.$store.state.loginInfo.id,
            itemId: x.itemId,
            goodQty : x.qty == undefined ? 0 : x.qty,
            asAgentId: 3,
            memo: x.memo == null ? '' : x.memo,
            creatorId: this.$store.state.loginInfo.id
          }
          result.push(saveForm);
        })
        this.$swal({
          type: 'warning',
          text: '자재 요청을 하시겠습니까?',
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니요',
        }).then((response) => {
          if (response.value) {
            let chkValue = "N";
            _.forEach(result, node => {
              if (node.goodQty === 0 || node.goodQty === '') {
                chkValue = "Y";
              }
            })
            if (chkValue === "Y") return this.$swal({ type: 'warning', text: '요청수량을 확인해주세요.' })
            else {
              this.$store.commit('loading')
              this.$http.post(("/api/agent/reqMateList/save"), result).then(res => {
                this.$swal({ type: 'success', text: '자재를 요청하였습니다.' })
                    .then(res => {
                      if (res) {
                        this.goOpen();
                      }
                    })
              }).catch((e) => {
                this.$swal({type: 'warning', text: '자재요청에 실패 했습니다.'})
              }).finally(() => {
                this.$store.commit('finish');
              });
            }
          }
        })
      }
      else {
        this.$swal({
          type: 'warning',
          text: '자재를 선택해 주십시요.'
        });
      }
    },
    async init() {
      this.$store.commit('loading');
      this.createMainColumnDefs();
      this.$store.commit('finish');
    },
    goOpen(){
      this.rowData = [];
      this.$store.commit('loading')
      let vForm = {
        companyId : this.form.companyId,
        maker : this.form.maker,                // 제조사
        itemGroup : (this.form.subItemGroup.length <= 0 || this.form.subItemGroup === '')  ? this.form.itemGroup : this.form.subItemGroup,     // 제품군
        modelGroup : (this.form.subItemGroup.length <= 0 || this.form.subItemGroup === '')  ? this.form.itemGroup : this.form.subItemGroup,     // 제품군
        useModelNm : this.form.useModelNm,       // 모델명
        modelNm : this.form.modelNm,            // 모델명
        description : this.form.description,    // 구분
        itemCd : this.form.itemCd,              // 품번
        itemNm : this.form.itemNm,              // 품명
        asAgentId : this.$store.state.loginInfo.asAgentId,
        sortType : this.form.sortType,
        page : this.form.page,
        totalPage : this.form.totalPage,
        curPage : this.form.curPage,
        totalCount : this.form.totalCount,
        processTime : this.form.processTime,
        qty: 0,
        memo: '',
        userId: this.$store.state.loginInfo.id
      }

      //모델 inputBox에 text 기입시 분기 처리 되어있음(as-is)
      let postUrl;
      if (this.form.useModelNm === '') {
        vForm.modelNm = this.form.modelNm;
        postUrl = "/api/workMng/mateEntering/popup/list";
      } else {
        vForm.modelNm = this.form.useModelNm;
        postUrl = "/api/workMng/reqMateEnter/popup/list";
      }

      this.$http.post((postUrl), vForm, {timeout: 60000*30}
      ).then(response => {
        this.rowData = response.data
      }).finally(() => {
        this.$store.commit('finish')
      });
    },
    chkNumber(params, flag, excRt){
      var result = '';
      var val = params.value;
      var data = this.data;

      if(flag === 'sub') data = this.subData;

      if(!_.isEmpty(val) || _.isNumber(val)){
        val = val.toString();

        if (excRt === 'excRt') result = this.$numeral(val).format('0,0.00');
        else result = this.$numeral(val).format('0,0');
      }
      return result
    },
    getNumberFormat(val) {
      if(val){
        if(typeof val === "string"){
          val = val.replace(/[^0-9]/g, "")
        }

        return Math.floor(val).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    }
  },
  created() {
    //this.form.modelNm = this.data.modelNm;
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
}
</script>

<style lang="scss" scoped>
</style>